import { Link, useNavigate } from 'react-router-dom'
import { FiMenu, FiX, FiLogOut, FiSettings, FiUser, FiCreditCard } from 'react-icons/fi'
import { HiTicket } from 'react-icons/hi2'
import { useState } from 'react'
import useAuthStore from '../stores/authStore'

export default function Navbar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const { isAuthenticated, user, logout, isAdmin, isCashier } = useAuthStore()
    const navigate = useNavigate()

    const handleLogout = async () => {
        await logout()
        navigate('/')
    }

    return (
        <nav
            className="fixed top-0 left-0 right-0 z-50 glass bg-black/50"
            style={{ textShadow: '1px 1px 0px rgba(255,255,255,0.15)' }}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                    {/* Logo — place your file at frontend/public/logo.png (or .svg/.webp) */}
                    <Link to="/" className="flex items-center">
                        <img
                            src="/logo.png"
                            alt={window.t('bileti_blagoevgrad')}
                            className="h-10 w-auto object-contain"
                            style={{ height: '62px' }}
                        />
                    </Link>

                    {/* Desktop Navigation */}
                    <div className="hidden md:flex items-center space-x-8">
                        <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                            {window.t('sabitiya')}
                        </Link>

                        {isAuthenticated ? (
                            <>
                                <Link to="/my-tickets" className="text-gray-300 hover:text-white transition-colors flex items-center gap-2">
                                    <HiTicket />
                                    {window.t('moite_bileti')}
                                </Link>

                                {isAdmin() && (
                                    <Link to="/admin" className="text-gray-300 hover:text-white transition-colors flex items-center gap-2">
                                        <FiSettings />
                                        {window.t('admin')}
                                    </Link>
                                )}

                                {isCashier() && (
                                    <Link to="/admin/cashier" className="text-gray-300 hover:text-white transition-colors flex items-center gap-2">
                                        <FiCreditCard />
                                        {window.t('kasa')}
                                    </Link>
                                )}

                                <Link to="/profile" className="text-gray-300 hover:text-white transition-colors flex items-center gap-2">
                                    <FiUser />
                                    {window.t('profil')}
                                </Link>

                                <div className="flex items-center space-x-4">
                                    <span className="text-gray-400">
                                        {user?.name?.split(' ')[0]}
                                    </span>
                                    <button
                                        onClick={handleLogout}
                                        className="text-gray-300 hover:text-white transition-colors"
                                    >
                                        <FiLogOut className="w-5 h-5" />
                                    </button>
                                </div>
                            </>
                        ) : (
                            <div className="flex items-center space-x-4">
                                <Link to="/login" className="text-gray-300 hover:text-white transition-colors">
                                    {window.t('vhod')}
                                </Link>
                                <Link to="/register" className="btn-primary text-sm py-2">
                                    {window.t('registratsiya')}
                                </Link>
                            </div>
                        )}

                        <div className="ml-4 flex items-center">
                            <select
                                className="bg-transparent text-gray-300 border border-gray-700 rounded px-2 py-1 text-sm outline-none cursor-pointer hover:text-white"
                                value={localStorage.getItem('app_lang') || 'bg'}
                                onChange={(e) => {
                                    localStorage.setItem('app_lang', e.target.value);
                                    window.location.reload();
                                }}
                            >
                                <option value="bg" className="bg-gray-900">БГ</option>
                                <option value="en" className="bg-gray-900">EN</option>
                            </select>
                        </div>
                    </div>

                    {/* Mobile menu button */}
                    <button
                        className="md:hidden text-gray-300 hover:text-white"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        {isMenuOpen ? <FiX className="w-6 h-6" /> : <FiMenu className="w-6 h-6" />}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {
                isMenuOpen && (
                    <div className="md:hidden glass border-t border-gray-800">
                        <div className="px-4 py-4 space-y-4">
                            <Link
                                to="/"
                                className="block text-gray-300 hover:text-white"
                                onClick={() => setIsMenuOpen(false)}
                            >
                                {window.t('sabitiya')}
                            </Link>

                            {isAuthenticated ? (
                                <>
                                    <Link
                                        to="/my-tickets"
                                        className="block text-gray-300 hover:text-white"
                                        onClick={() => setIsMenuOpen(false)}
                                    >
                                        {window.t('moite_bileti')}
                                    </Link>
                                    {isAdmin() && (
                                        <Link
                                            to="/admin"
                                            className="block text-gray-300 hover:text-white"
                                            onClick={() => setIsMenuOpen(false)}
                                        >
                                            {window.t('admin_panel')}
                                        </Link>
                                    )}
                                    {isCashier() && (
                                        <Link
                                            to="/admin/cashier"
                                            className="block text-gray-300 hover:text-white"
                                            onClick={() => setIsMenuOpen(false)}
                                        >
                                            {window.t('kasa')}
                                        </Link>
                                    )}
                                    <Link
                                        to="/profile"
                                        className="block text-gray-300 hover:text-white"
                                        onClick={() => setIsMenuOpen(false)}
                                    >
                                        {window.t('moyat_profil')}
                                    </Link>
                                    <button
                                        onClick={() => { handleLogout(); setIsMenuOpen(false); }}
                                        className="w-full text-left text-gray-300 hover:text-white"
                                    >
                                        {window.t('izhod')}
                                    </button>
                                </>
                            ) : (
                                <>
                                    <Link
                                        to="/login"
                                        className="block text-gray-300 hover:text-white"
                                        onClick={() => setIsMenuOpen(false)}
                                    >
                                        {window.t('vhod')}
                                    </Link>
                                    <Link
                                        to="/register"
                                        className="block btn-primary text-center"
                                        onClick={() => setIsMenuOpen(false)}
                                    >
                                        {window.t('registratsiya')}
                                    </Link>
                                </>
                            )}

                            <div className="pt-4 border-t border-gray-800 flex justify-between items-center">
                                <span className="text-gray-400">Език / Language</span>
                                <select
                                    className="bg-gray-800 text-white border border-gray-700 rounded px-3 py-1 text-sm outline-none cursor-pointer"
                                    value={localStorage.getItem('app_lang') || 'bg'}
                                    onChange={(e) => {
                                        localStorage.setItem('app_lang', e.target.value);
                                        window.location.reload();
                                    }}
                                >
                                    <option value="bg">Български</option>
                                    <option value="en">English</option>
                                </select>
                            </div>
                        </div>
                    </div>
                )
            }
        </nav >
    )
}
